export enum Configuration {
  ApiUrl = 'API_URL',
  PaymentsUrl = 'PAYMENTS_URL',
  DebugRecordSessionEnabled = 'DEBUG_RECORD_SESSION_ENABLED',
  AccountId = 'ACCOUNT_ID',
  EmployeeId = 'EMPLOYEE_ID',
  OauthSessionGrantType = 'OAUTH_SESSION_GRANT_TYPE',
  OauthClientId = 'OAUTH_CLIENT_ID',
  OauthClientSecret = 'OAUTH_CLIENT_SECRET',
  UserUuid = 'USER_UUID',
  IsUsingPaymentsPlatform = 'IS_USING_PAYMENTS_PLATFORM',
  MaxTotalFilesizeEmailAttachmentsInMegaBytes = 'MAX_TOTAL_FILESIZE_EMAIL_ATTACHMENTS_IN_MEGA_BYTES',
}

export interface ConfigurationInitialState {
  [Configuration.ApiUrl]: string;
  [Configuration.PaymentsUrl]: string;
  [Configuration.DebugRecordSessionEnabled]: boolean;
  [Configuration.AccountId]: number;
  [Configuration.EmployeeId]: number;
  [Configuration.OauthSessionGrantType]: string;
  [Configuration.OauthClientId]: string;
  [Configuration.OauthClientSecret]: string;
  [Configuration.UserUuid]: string;
  [Configuration.IsUsingPaymentsPlatform]: boolean;
  [Configuration.MaxTotalFilesizeEmailAttachmentsInMegaBytes]: number;
}

export function getConfig<K extends Configuration>(key: K): ConfigurationInitialState[K];
export function getConfig(): ConfigurationInitialState;
export function getConfig(key?: Configuration) {
  if (key) {
    return window.top!.__INITIAL_STATE__.config[key];
  }
  return window.top!.__INITIAL_STATE__.config;
}
